<template>
	<div>
		<div v-if="loggedInEmployee.isAdmin">
			<v-list two-line>
				<v-list-tile @click="navToCoreValues">
					<v-list-tile-avatar class="mr-3">
						<v-icon>mdi-heart-pulse</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title>Core Values</v-list-tile-title>
						<v-list-tile-sub-title>Manage your company's core values</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-divider inset></v-divider>

				<v-list-tile @click="navToDepartments">
					<v-list-tile-avatar class="mr-3">
						<v-icon>mdi-account-group-outline</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title>Departments</v-list-tile-title>
						<v-list-tile-sub-title>Manage your company's core values</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-divider v-if="$_hasAccessToModule('performanceReviews')" inset></v-divider>

				<v-list-tile v-if="$_hasAccessToModule('performanceReviews')" @click="navToMeetingRooms">
					<v-list-tile-avatar class="mr-3">
						<v-icon>mdi-map-marker</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title>Meeting Rooms</v-list-tile-title>
						<v-list-tile-sub-title>Manage your company's meeting rooms</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</div>
		<div v-else>You do not have access</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
		created() {
			this.$store.dispatch('setPageTitle', 'Company Settings');
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee'
			})
		},
		methods: {
			navToCoreValues() {
				this.$router.push({ name: 'coreValues' });
			},
			navToDepartments() {
				this.$router.push({ name: 'departments' });
			},
			navToMeetingRooms() {
				this.$router.push({ name: 'meetingLocations' });
			}
		}
	};
</script>